// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderProducts_wrapper__tcJgm","header":"OrderProducts_header__ZHZi1","totalAmountWrapper":"OrderProducts_totalAmountWrapper__28Uan","footer":"OrderProducts_footer__RQVbx"};